import { Component, HostListener, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppUtils } from '../../../core/config/app.utils';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { FilesService } from '../../../core/services/files.service';
import { FleetService } from '../../../core/services/fleet.service';
import { SETTINGS } from '../../../core/config/common.settings';
import { ActionAlert } from '../../../core/dto/actionAlert';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  canDeactivateGuardService,
  IDeactivateComponent,
} from '../../../core/guards/deactivate.gaurd';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

const ADD_EDIT_FLEET_VEHICLE_BOOK_UPLOAD = 'ADD_EDIT_FLEET_VEHICLE_BOOK_UPLOAD';
const ADD_EDIT_FLEET_VEHICLE_OTHER_UPLOAD =
  'ADD_EDIT_FLEET_VEHICLE_OTHER_UPLOAD';
const ADD_EDIT_FLEET_BANK_DETAILS_UPLOAD = 'ADD_EDIT_FLEET_BANK_DETAILS_UPLOAD';
const ADD_EDIT_FLEET_VEHICLE_IMAGES_UPLOAD =
  'ADD_EDIT_FLEET_VEHICLE_IMAGES_UPLOAD';

@Component({
  selector: 'app-add-edit-fleet',
  templateUrl: './add-edit-fleet.component.html',
  styleUrls: ['./add-edit-fleet.component.scss'],
})
export class AddEditFleetComponent implements OnInit, IDeactivateComponent {
  breadcrumbs: any[] = [];
  fleetForm: FormGroup | any;
  formErrors: any;
  isVisibleDiscardPopUp = false;
  fleetId: any;
  backLocation: any;
  isAdd = false;
  vehicleImgUploadFiles: any[] = [];
  vehicleBookUploadFile: any[] = [];
  vehicleOtherInfoUploadFiles: any[] = [];
  bankInfoUploadFiles: any[] = [];
  imgUploadPlaceholder = SETTINGS.UPLOAD_PLACEHOLDER;
  vehicleImgUploading = false;
  vehicleBookUploading = false;
  vehicleOtherInfoUploading = false;
  bankInfoUploading = false;
  sectionHideByVehicleType = true;
  vehicleCat: any;
  vehicleCatCode: any = {};
  isLeasedVehicle = false;
  isRentingPeriodOther = false;
  isEntitledKMSOther = false;
  isEntitledKMSPrice = false;
  fleetInfo: any;
  subbmit = false;
  actionMessage = new ActionAlert();
  loading = false;
  fuelType = SETTINGS.FUEL_TYPE;
  transmissionType = SETTINGS.TRANSMISSION_TYPE;
  vehicleBrandType = SETTINGS.VEHICLE_BRAND_TYPE;
  agreementRentingPeriodOptions = SETTINGS.AGREEMENT_RENTING_PERIOD;
  agreementEntitledKmsOptions = SETTINGS.AGREEMENT_ENTITLED_KMS;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): string | undefined {
    const confirmationMessage =
      'You have unsaved changes. Do you really want to leave?';
    $event.returnValue = confirmationMessage; // Standard for most browsers
    return confirmationMessage; // For some older browsers
  }

  latestServiceDisabledDate = (current: Date): boolean => {
    return current > new Date();
  };

  // formatterPercentFuel = (value: number): string => `${value} %`;
  // parserPercentFuel = (value: string): string => value.replace(' %', '');
  formatterCurrencyMonthRent = (value: number): string => `Rs. ${value}`;
  parserCurrencyMonthRent = (value: string): string =>
    value.replace('Rs. ', '');
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private filesService: FilesService,
    private fleetService: FleetService,
    private router: Router,
    private message: NzMessageService,
  ) {
    this.initFormErrors();
  }

  ngOnInit() {
    this.fleetId = this.route.snapshot.paramMap.get('id');
    this.isAdd = !this.fleetId;
    this.getVehicleCategory();
    this.fleetFormInit();

    if (this.fleetId) {
      this.loading = true;
      this.fleetService.getOneFleetById(this.fleetId).then((res) => {
        this.backLocation = this.route.snapshot.paramMap.get('backLoc');
        this.fleetInfo = res;
        this.breadcrumbs = [
          {
            title: 'Fleet',
            icon: 'car',
            route: ['/admin/fleets'],
          },
          {
            title: `${res?.vehicleDetails?.registrationNumber}`,
            route: [
              `/admin/fleets/${this.fleetId}`,
              { pageName: 'generalInformation' },
            ],
          },
          {
            title: 'Edit',
          },
        ];

        this.fleetForm.get('generalInfo').patchValue(res?.generalInformation);
        this.fleetForm
          .get('generalInfo')
          .get('vehicleCategory')
          .patchValue(res?.generalInformation?.vehicleCategory);
        this.vehicleImgUploadFiles = res?.generalInformation?.vehicleImg || [];
        this.fleetForm.get('ownerInfo').patchValue(res?.ownershipDetails);
        this.vehicleBookUploadFile = res.ownershipDetails?.vehicleBook || [];
        this.fleetForm.get('vehicleInfo').patchValue(res?.vehicleDetails);
        this.fleetForm.get('agreementInfo').patchValue(res?.agreementDetails);
        this.fleetForm
          .get('vehicleInventoryInfo')
          .patchValue(res?.vehicleInventory);
        this.fleetForm.get('otherInfo').patchValue(res?.otherDetails);
        this.vehicleOtherInfoUploadFiles =
          res?.otherDetails?.otherInfoFiles || [];
        this.fleetForm.get('paymentInfo').patchValue(res?.paymentDetails);
        this.bankInfoUploadFiles = res?.paymentDetails?.bankInfoFiles || [];
        this.loading = false;
      });
    } else {
      this.breadcrumbs = [
        {
          title: 'Fleet',
          icon: 'car',
          route: '/admin/fleets',
        },
        {
          title: 'Add New Vehicle',
        },
      ];
    }
    this.uploadLoader();
  }

  uploadLoader() {
    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      switch (res.type) {
        case ADD_EDIT_FLEET_VEHICLE_IMAGES_UPLOAD:
          this.vehicleImgUploading = res.loading;
          break;
        case ADD_EDIT_FLEET_VEHICLE_BOOK_UPLOAD:
          this.vehicleBookUploading = res.loading;
          break;
        case ADD_EDIT_FLEET_VEHICLE_OTHER_UPLOAD:
          this.vehicleOtherInfoUploading = res.loading;
          break;
        case ADD_EDIT_FLEET_BANK_DETAILS_UPLOAD:
          this.bankInfoUploading = res.loading;
          break;
      }
    });
  }

  fleetFormInit() {
    this.fleetForm = this.fb.group({
      generalInfo: this.fb.group({
        vehicleType: [{ value: null, disabled: !this.isAdd }],
        vehicleCategory: [null],
        rentCarCode: [null],
        transferCode: [null],
      }),

      ownerInfo: this.fb.group({
        ownerName: [{ value: null, disabled: !this.isAdd }],
        contactPerson: [null],
        contactNumber: [[]],
        contactEmail: [null],
        permanentAddress: [null],
        currentAddress: [null],
        registrationNumber: [null],
        issuedDate: [null],
      }),

      vehicleInfo: this.fb.group({
        vehicleBrand: [{ value: null, disabled: !this.isAdd }],
        vehicleModel: [{ value: null, disabled: !this.isAdd }],
        engineNumber: [null],
        chassisNumber: [null],
        fuelType: [null],
        transmission: [null],
        manufactureDate: [{ value: null, disabled: !this.isAdd }],
        registerDate: [null],
        seatsNumber: [null],
        registrationNumber: [{ value: null, disabled: !this.isAdd }],
        color: [null],
        LicensePlate: [null],
      }),

      agreementInfo: this.fb.group({
        MonthRentalAmount: [''],
        rentingPeriod: [null],
        rentingPeriodOther: [null],
        amount: [''],
        entitledKMS: [null],
        entitledKMOther: [''],
      }),

      vehicleInventoryInfo: this.fb.group({
        odometer: [''],
        fuelLevel: [0],
        latestServiceDate: [null],
        latestServiceMileage: [''],
        serviceDuration: [''],
        serviceResponsible: [null],
        serviceOilChangeResponsible: [null],
        latestOilChangeDate: [null],
        latestOilChangedMileage: [''],
        oilChangeDuration: [''],
        oilChangeResponsible: [null],
      }),

      otherInfo: this.fb.group({
        insuranceName: [null],
        insuranceType: [null],
        insuranceExpDate: [null],
        ecoTestExpDate: [null],
        revenueLicenceExpDate: [null],
        isLeasedVehicle: [false],
        leaseComName: [null],
      }),

      paymentInfo: this.fb.group({
        paymentMethod: ['TRANSFER'],
        bankName: [null],
        branchName: [null],
        accountType: [null],
        accountHolder: [null],
        accountNumber: [null],
      }),
    });
    this.initCommonFormValidation();

    this.fleetForm
      .get('generalInfo')
      .get('vehicleType')
      .valueChanges.subscribe((res: any) => {
        this.vehicleTypeCheck(res);
      });
    this.fleetForm
      .get('generalInfo')
      .get('vehicleCategory')
      .valueChanges.subscribe((res: any) => {
        this.catCodeChangeOnVehicleCategory(res);
      });
    this.fleetForm
      .get('otherInfo')
      .get('isLeasedVehicle')
      .valueChanges.subscribe((res: any) => {
        this.isLeasedVehicleCheck(res);
      });
    this.fleetForm
      .get('agreementInfo')
      .get('rentingPeriod')
      .valueChanges.subscribe((res: any) => {
        this.rentingPeriodCheck(res);
      });
    this.fleetForm
      .get('agreementInfo')
      .get('entitledKMS')
      .valueChanges.subscribe((res: any) => {
        this.entitledKmOtherCheck(res);
        this.entitledKmExceedLimitCheck(res);
      });

    this.fleetForm.valueChanges.subscribe(() => {
      this.formErrors.generalInfo = AppUtils.getFormErrors(
        this.fleetForm.get('generalInfo'),
        this.formErrors.generalInfo,
      );
      this.formErrors.ownerInfo = AppUtils.getFormErrors(
        this.fleetForm.get('ownerInfo'),
        this.formErrors.ownerInfo,
      );
      this.formErrors.vehicleInfo = AppUtils.getFormErrors(
        this.fleetForm.get('vehicleInfo'),
        this.formErrors.vehicleInfo,
      );
      this.formErrors.agreementInfo = AppUtils.getFormErrors(
        this.fleetForm.get('agreementInfo'),
        this.formErrors.agreementInfo,
      );
      this.formErrors.vehicleInventoryInfo = AppUtils.getFormErrors(
        this.fleetForm.get('vehicleInventoryInfo'),
        this.formErrors.vehicleInventoryInfo,
      );
      this.formErrors.otherInfo = AppUtils.getFormErrors(
        this.fleetForm.get('otherInfo'),
        this.formErrors.otherInfo,
      );
      this.formErrors.paymentInfo = AppUtils.getFormErrors(
        this.fleetForm.get('paymentInfo'),
        this.formErrors.paymentInfo,
      );
    });
  }

  initFormErrors() {
    this.formErrors = {
      generalInfo: {
        vehicleType: {},
        vehicleCategory: {},
        rentCarCode: {},
        transferCode: {},
      },
      ownerInfo: {
        ownerName: {},
        contactPerson: {},
        contactNumber: {},
        contactEmail: {},
        permanentAddress: {},
        currentAddress: {},
        registrationNumber: {},
        issuedDate: {},
      },
      vehicleInfo: {
        vehicleBrand: {},
        vehicleModel: {},
        engineNumber: {},
        chassisNumber: {},
        fuelType: {},
        transmission: {},
        manufactureDate: {},
        registerDate: {},
        seatsNumber: {},
        registrationNumber: {},
        color: {},
        LicensePlate: {},
      },
      agreementInfo: {
        MonthRentalAmount: {},
        rentingPeriod: {},
        rentingPeriodOther: {},
        amount: {},
        entitledKMS: {},
        entitledKMOther: {},
      },
      vehicleInventoryInfo: {
        odometer: {},
        fuelLevel: {},
        latestServiceDate: {},
        latestServiceMileage: {},
        serviceDuration: {},
        serviceResponsible: {},
        serviceOilChangeResponsible: {},
        latestOilChangeDate: {},
        latestOilChangedMileage: {},
        oilChangeDuration: {},
        oilChangeResponsible: {},
      },
      otherInfo: {
        insuranceName: {},
        insuranceType: {},
        insuranceExpDate: {},
        ecoTestExpDate: {},
        revenueLicenceExpDate: {},
        isLeasedVehicle: {},
        leaseComName: {},
      },
      paymentInfo: {
        paymentMethod: {},
        bankName: {},
        branchName: {},
        accountType: {},
        accountHolder: {},
        accountNumber: {},
      },
    };
  }

  initCommonFormValidation() {
    this.fleetForm
      .get('generalInfo')
      .get('vehicleType')
      .addValidators(Validators.required);
    this.fleetForm
      .get('generalInfo')
      .get('vehicleCategory')
      .addValidators(Validators.required);

    this.fleetForm
      .get('vehicleInfo')
      .get('vehicleBrand')
      .addValidators(Validators.required);
    this.fleetForm
      .get('vehicleInfo')
      .get('vehicleModel')
      .addValidators(
        Validators.compose([Validators.required, Validators.maxLength(15)]),
      );
    this.fleetForm
      .get('vehicleInfo')
      .get('engineNumber')
      .addValidators(Validators.maxLength(20));
    this.fleetForm
      .get('vehicleInfo')
      .get('chassisNumber')
      .addValidators(Validators.maxLength(20));
    this.fleetForm
      .get('vehicleInfo')
      .get('fuelType')
      .addValidators(Validators.required);
    this.fleetForm
      .get('vehicleInfo')
      .get('transmission')
      .addValidators(Validators.required);
    this.fleetForm
      .get('vehicleInfo')
      .get('manufactureDate')
      .addValidators(Validators.required);
    this.fleetForm
      .get('vehicleInfo')
      .get('seatsNumber')
      .addValidators(Validators.required);
    this.fleetForm
      .get('vehicleInfo')
      .get('registrationNumber')
      .addValidators(
        Validators.compose([Validators.required, Validators.maxLength(15)]),
      );
    this.fleetForm
      .get('vehicleInfo')
      .get('color')
      .addValidators(
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.pattern(SETTINGS.REGEX.LETTERS.EXP),
        ]),
      );

    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('odometer')
      .addValidators(
        Validators.compose([Validators.required, Validators.maxLength(15)]),
      );
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('fuelLevel')
      .addValidators(
        Validators.compose([Validators.required, Validators.maxLength(15)]),
      );
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('latestServiceDate')
      .addValidators(Validators.required);
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('latestServiceMileage')
      .addValidators(
        Validators.compose([Validators.required, Validators.maxLength(15)]),
      );
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceDuration')
      .addValidators(Validators.required);
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceResponsible')
      .addValidators(Validators.required);
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceOilChangeResponsible')
      .addValidators(Validators.required);
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('latestOilChangeDate')
      .addValidators(Validators.required);
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('latestOilChangedMileage')
      .addValidators(
        Validators.compose([Validators.required, Validators.maxLength(15)]),
      );
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('oilChangeDuration')
      .addValidators(
        Validators.compose([Validators.required, Validators.maxLength(15)]),
      );
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('oilChangeResponsible')
      .addValidators(Validators.required);

    this.fleetForm
      .get('otherInfo')
      .get('insuranceName')
      .addValidators(
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.pattern(SETTINGS.REGEX.LETTERS.EXP),
        ]),
      );
    this.fleetForm
      .get('otherInfo')
      .get('insuranceType')
      .addValidators(Validators.required);
    this.fleetForm
      .get('otherInfo')
      .get('insuranceExpDate')
      .addValidators(Validators.required);
    this.fleetForm
      .get('otherInfo')
      .get('ecoTestExpDate')
      .addValidators(Validators.required);
    this.fleetForm
      .get('otherInfo')
      .get('revenueLicenceExpDate')
      .addValidators(Validators.required);
  }

  addFormValidationOnVehicleType() {
    this.fleetForm
      .get('ownerInfo')
      .get('ownerName')
      .addValidators(
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.pattern(SETTINGS.REGEX.LETTERS.EXP),
        ]),
      );
    this.fleetForm
      .get('ownerInfo')
      .get('contactPerson')
      .addValidators(
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.pattern(SETTINGS.REGEX.LETTERS.EXP),
        ]),
      );
    this.fleetForm
      .get('ownerInfo')
      .get('contactNumber')
      .addValidators(this.requiredMaxLengthPatternValidator);
    this.fleetForm
      .get('ownerInfo')
      .get('contactEmail')
      .addValidators(Validators.email);
    this.fleetForm
      .get('ownerInfo')
      .get('permanentAddress')
      .addValidators(
        Validators.compose([Validators.required, Validators.maxLength(70)]),
      );
    this.fleetForm
      .get('ownerInfo')
      .get('currentAddress')
      .addValidators(
        Validators.compose([Validators.required, Validators.maxLength(70)]),
      );
    this.fleetForm
      .get('ownerInfo')
      .get('registrationNumber')
      .addValidators(
        Validators.compose([Validators.required, Validators.maxLength(30)]),
      );
    this.fleetForm
      .get('ownerInfo')
      .get('issuedDate')
      .addValidators(Validators.required);

    this.fleetForm
      .get('agreementInfo')
      .get('MonthRentalAmount')
      .addValidators(
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.pattern(SETTINGS.REGEX.PHONE.EXP),
        ]),
      );
    this.fleetForm
      .get('agreementInfo')
      .get('rentingPeriod')
      .addValidators(Validators.required);
    this.fleetForm
      .get('agreementInfo')
      .get('entitledKMS')
      .addValidators(Validators.required);

    this.fleetForm
      .get('paymentInfo')
      .get('paymentMethod')
      .addValidators(Validators.required);
    this.fleetForm
      .get('paymentInfo')
      .get('bankName')
      .addValidators(
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.pattern(SETTINGS.REGEX.LETTERS.EXP),
        ]),
      );
    this.fleetForm
      .get('paymentInfo')
      .get('branchName')
      .addValidators(
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.pattern(SETTINGS.REGEX.LETTERS.EXP),
        ]),
      );
    this.fleetForm
      .get('paymentInfo')
      .get('accountType')
      .addValidators(Validators.required);
    this.fleetForm
      .get('paymentInfo')
      .get('accountHolder')
      .addValidators(
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.pattern(SETTINGS.REGEX.LETTERS.EXP),
        ]),
      );
    this.fleetForm
      .get('paymentInfo')
      .get('accountNumber')
      .addValidators(
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.pattern(/^[0-9]*$/),
        ]),
      );
  }

  clearFormValidationOnVehicleType() {
    this.fleetForm.get('ownerInfo').get('ownerName').clearValidators();
    this.fleetForm.get('ownerInfo').get('contactPerson').clearValidators();
    this.fleetForm.get('ownerInfo').get('contactNumber').clearValidators();
    this.fleetForm.get('ownerInfo').get('contactEmail').clearValidators();
    this.fleetForm.get('ownerInfo').get('permanentAddress').clearValidators();
    this.fleetForm.get('ownerInfo').get('currentAddress').clearValidators();
    this.fleetForm.get('ownerInfo').get('registrationNumber').clearValidators();
    this.fleetForm.get('ownerInfo').get('issuedDate').clearValidators();

    this.fleetForm
      .get('agreementInfo')
      .get('MonthRentalAmount')
      .clearValidators();
    this.fleetForm.get('agreementInfo').get('rentingPeriod').clearValidators();
    this.fleetForm
      .get('agreementInfo')
      .get('rentingPeriodOther')
      .clearValidators();
    this.fleetForm.get('agreementInfo').get('entitledKMS').clearValidators();
    this.fleetForm
      .get('agreementInfo')
      .get('entitledKMOther')
      .clearValidators();

    this.fleetForm.get('paymentInfo').get('paymentMethod').clearValidators();
    this.fleetForm.get('paymentInfo').get('bankName').clearValidators();
    this.fleetForm.get('paymentInfo').get('branchName').clearValidators();
    this.fleetForm.get('paymentInfo').get('accountType').clearValidators();
    this.fleetForm.get('paymentInfo').get('accountHolder').clearValidators();
    this.fleetForm.get('paymentInfo').get('accountNumber').clearValidators();
  }

  updateFormValidationOnVehicleType() {
    this.fleetForm.get('ownerInfo').get('ownerName').updateValueAndValidity();
    this.fleetForm
      .get('ownerInfo')
      .get('contactPerson')
      .updateValueAndValidity();
    this.fleetForm
      .get('ownerInfo')
      .get('contactNumber')
      .updateValueAndValidity();
    this.fleetForm
      .get('ownerInfo')
      .get('contactEmail')
      .updateValueAndValidity();
    this.fleetForm
      .get('ownerInfo')
      .get('permanentAddress')
      .updateValueAndValidity();
    this.fleetForm
      .get('ownerInfo')
      .get('currentAddress')
      .updateValueAndValidity();
    this.fleetForm
      .get('ownerInfo')
      .get('registrationNumber')
      .updateValueAndValidity();
    this.fleetForm.get('ownerInfo').get('issuedDate').updateValueAndValidity();

    this.fleetForm
      .get('agreementInfo')
      .get('MonthRentalAmount')
      .updateValueAndValidity();
    this.fleetForm
      .get('agreementInfo')
      .get('rentingPeriod')
      .updateValueAndValidity();
    // this.fleetForm.get('agreementInfo').get('rentingPeriodOther').updateValueAndValidity();
    this.fleetForm
      .get('agreementInfo')
      .get('entitledKMS')
      .updateValueAndValidity();
    // this.fleetForm.get('agreementInfo').get('entitledKMOther').updateValueAndValidity();

    this.fleetForm
      .get('paymentInfo')
      .get('paymentMethod')
      .updateValueAndValidity();
    this.fleetForm.get('paymentInfo').get('bankName').updateValueAndValidity();
    this.fleetForm
      .get('paymentInfo')
      .get('branchName')
      .updateValueAndValidity();
    this.fleetForm
      .get('paymentInfo')
      .get('accountType')
      .updateValueAndValidity();
    this.fleetForm
      .get('paymentInfo')
      .get('accountHolder')
      .updateValueAndValidity();
    this.fleetForm
      .get('paymentInfo')
      .get('accountNumber')
      .updateValueAndValidity();
  }

  fleetFormValueResetOnVehicleType() {
    this.fleetForm.get('generalInfo').get('vehicleCategory').reset();

    this.fleetForm.get('ownerInfo').get('ownerName').reset();
    this.fleetForm.get('ownerInfo').get('contactPerson').reset();
    this.fleetForm.get('ownerInfo').get('contactNumber').reset();
    this.fleetForm.get('ownerInfo').get('contactEmail').reset();
    this.fleetForm.get('ownerInfo').get('permanentAddress').reset();
    this.fleetForm.get('ownerInfo').get('currentAddress').reset();
    this.fleetForm.get('ownerInfo').get('registrationNumber').reset();
    this.fleetForm.get('ownerInfo').get('issuedDate').reset();

    this.fleetForm.get('vehicleInfo').get('vehicleBrand').reset();
    this.fleetForm.get('vehicleInfo').get('vehicleModel').reset();
    this.fleetForm.get('vehicleInfo').get('engineNumber').reset();
    this.fleetForm.get('vehicleInfo').get('chassisNumber').reset();
    this.fleetForm.get('vehicleInfo').get('fuelType').reset();
    this.fleetForm.get('vehicleInfo').get('transmission').reset();
    this.fleetForm.get('vehicleInfo').get('manufactureDate').reset();
    this.fleetForm.get('vehicleInfo').get('registerDate').reset();
    this.fleetForm.get('vehicleInfo').get('seatsNumber').reset();
    this.fleetForm.get('vehicleInfo').get('registrationNumber').reset();
    this.fleetForm.get('vehicleInfo').get('color').reset();

    this.fleetForm.get('agreementInfo').get('MonthRentalAmount').patchValue('');
    this.fleetForm.get('agreementInfo').get('rentingPeriod').reset();
    // this.fleetForm.get('agreementInfo').get('rentingPeriodOther').reset();
    this.fleetForm.get('agreementInfo').get('entitledKMS').reset();
    // this.fleetForm.get('agreementInfo').get('entitledKMOther').reset();

    this.fleetForm.get('vehicleInventoryInfo').get('odometer').patchValue('');
    this.fleetForm.get('vehicleInventoryInfo').get('fuelLevel').patchValue(0);
    this.fleetForm.get('vehicleInventoryInfo').get('latestServiceDate').reset();
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('latestServiceMileage')
      .patchValue('');
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceDuration')
      .patchValue('');
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceResponsible')
      .reset();
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceOilChangeResponsible')
      .reset();
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('latestOilChangeDate')
      .reset();
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('latestOilChangedMileage')
      .patchValue('');
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('oilChangeDuration')
      .patchValue('');
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('oilChangeResponsible')
      .reset();

    this.fleetForm.get('otherInfo').get('insuranceName').reset();
    this.fleetForm.get('otherInfo').get('insuranceType').reset();
    this.fleetForm.get('otherInfo').get('insuranceExpDate').reset();
    this.fleetForm.get('otherInfo').get('ecoTestExpDate').reset();
    this.fleetForm.get('otherInfo').get('revenueLicenceExpDate').reset();
    this.fleetForm.get('otherInfo').get('isLeasedVehicle').reset();
    this.fleetForm.get('otherInfo').get('leaseComName').reset();

    this.fleetForm
      .get('paymentInfo')
      .get('paymentMethod')
      .patchValue('TRANSFER');
    this.fleetForm.get('paymentInfo').get('bankName').reset();
    this.fleetForm.get('paymentInfo').get('branchName').reset();
    this.fleetForm.get('paymentInfo').get('accountType').reset();
    this.fleetForm.get('paymentInfo').get('accountHolder').reset();
    this.fleetForm.get('paymentInfo').get('accountNumber').reset();

    this.vehicleBookUploadFile = [];
    this.bankInfoUploadFiles = [];
  }

  requiredMaxLengthPatternValidator = (control: FormControl) => {
    if (!control?.value?.length) {
      return { required: true };
    }
    let isMaxlength = false;
    let isPhoneNum = false;
    control?.value.forEach((val: any) => {
      const regex = /^[0-9]*$/;
      if (!regex.test(val as string)) {
        isPhoneNum = true;
      }
      if (val.length > 10) {
        isMaxlength = true;
      }
    });
    if (isPhoneNum) {
      return { pattern: true };
    } else if (isMaxlength) {
      return { maxlength: true };
    } else {
      return {};
    }
  };

  async getVehicleCategory(): Promise<void> {
    this.vehicleCat = await this.fleetService.getAllVehicleCat();
  }

  vehicleTypeCheck(event: any) {
    this.fleetFormValueResetOnVehicleType();
    this.vehicleInventoryFieldsEnable();
    if (event === 'RENT') {
      this.sectionHideByVehicleType = false;
      this.addFormValidationOnVehicleType();
    } else {
      this.sectionHideByVehicleType = true;
      this.vehicleInventoryFieldsSelectAndDisable();
      this.clearFormValidationOnVehicleType();
    }
    this.updateFormValidationOnVehicleType();
  }
  vehicleInventoryFieldsSelectAndDisable() {
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceResponsible')
      .patchValue('SR');
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceResponsible')
      .disable();
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceOilChangeResponsible')
      .patchValue('SR');
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceOilChangeResponsible')
      .disable();
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('oilChangeResponsible')
      .patchValue('SR');
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('oilChangeResponsible')
      .disable();
  }
  vehicleInventoryFieldsEnable() {
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceResponsible')
      .enable();
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('serviceOilChangeResponsible')
      .enable();
    this.fleetForm
      .get('vehicleInventoryInfo')
      .get('oilChangeResponsible')
      .enable();
  }

  rentingPeriodCheck(event: any) {
    this.fleetForm
      .get('agreementInfo')
      .get('rentingPeriodOther')
      .clearValidators();
    if (event === 'OTHER') {
      this.isRentingPeriodOther = true;
      this.fleetForm
        .get('agreementInfo')
        .get('rentingPeriodOther')
        .patchValue(this.fleetInfo?.agreementDetails?.rentingPeriodOther);
      this.fleetForm
        .get('agreementInfo')
        .get('rentingPeriodOther')
        .addValidators(Validators.required);
    } else {
      this.isRentingPeriodOther = false;
      this.fleetForm.get('agreementInfo').get('rentingPeriodOther').reset();
    }
    this.fleetForm
      .get('agreementInfo')
      .get('rentingPeriodOther')
      .updateValueAndValidity();
  }

  entitledKmOtherCheck(event: any) {
    this.fleetForm
      .get('agreementInfo')
      .get('entitledKMOther')
      .clearValidators();
    if (event === 'OTHER') {
      this.isEntitledKMSOther = true;
      this.fleetForm
        .get('agreementInfo')
        .get('entitledKMOther')
        .patchValue(this.fleetInfo?.agreementDetails?.entitledKMOther || '');
      this.fleetForm
        .get('agreementInfo')
        .get('entitledKMOther')
        .addValidators(Validators.required);
    } else {
      this.isEntitledKMSOther = false;
      this.fleetForm.get('agreementInfo').get('entitledKMOther').reset();
    }
    this.fleetForm
      .get('agreementInfo')
      .get('entitledKMOther')
      .updateValueAndValidity();
  }
  entitledKmExceedLimitCheck(event: any) {
    this.fleetForm.get('agreementInfo').get('amount').clearValidators();
    if (event && event !== 'UNLIMITED') {
      this.isEntitledKMSPrice = true;
      this.fleetForm
        .get('agreementInfo')
        .get('amount')
        .patchValue(this.fleetInfo?.agreementDetails?.amount || '');
      this.fleetForm
        .get('agreementInfo')
        .get('amount')
        .addValidators(Validators.required);
    } else {
      this.isEntitledKMSPrice = false;
      this.fleetForm.get('agreementInfo').get('amount').reset();
    }
    this.fleetForm.get('agreementInfo').get('amount').updateValueAndValidity();
  }

  accHolderNameChange() {
    if (!this.fleetForm.get('paymentInfo').get('accountHolder').getRawValue()) {
      this.fleetForm
        .get('paymentInfo')
        .get('accountHolder')
        .patchValue(
          this.fleetForm.get('ownerInfo').get('ownerName').getRawValue(),
        );
    }
  }

  isLeasedVehicleCheck(event: any) {
    this.fleetForm.get('otherInfo').get('leaseComName').clearValidators();
    if (event) {
      this.isLeasedVehicle = true;
      this.fleetForm
        .get('otherInfo')
        .get('leaseComName')
        .patchValue(this.fleetInfo?.otherDetails?.leaseComName);
      this.fleetForm
        .get('otherInfo')
        .get('leaseComName')
        .addValidators(
          Validators.compose([
            Validators.required,
            Validators.maxLength(70),
            Validators.pattern(SETTINGS.REGEX.LETTERS.EXP),
          ]),
        );
    } else {
      this.isLeasedVehicle = false;
      this.fleetForm.get('otherInfo').get('leaseComName').reset();
    }
    this.fleetForm
      .get('otherInfo')
      .get('leaseComName')
      .updateValueAndValidity();
  }

  async catCodeChangeOnVehicleCategory(id: any): Promise<any> {
    this.fleetForm.get('generalInfo').get('rentCarCode').reset();
    this.fleetForm.get('generalInfo').get('transferCode').reset();
    this.vehicleCatCode = {};

    if (id) {
      this.vehicleCatCode = await this.fleetService.getVehicleCatCode(id);
      if (
        id?.toString() ===
        this.fleetInfo?.generalInformation?.vehicleCategory?.toString()
      ) {
        this.fleetForm
          .get('generalInfo')
          .get('rentCarCode')
          .patchValue(
            this.checkedValuePatch(
              this.vehicleCatCode.applicableRentCodes,
              this.fleetInfo.generalInformation.rentCarCode,
              'SELECTED',
            ),
          );
        this.fleetForm
          .get('generalInfo')
          .get('transferCode')
          .patchValue(
            this.checkedValuePatch(
              this.vehicleCatCode.applicableTransferCodes,
              this.fleetInfo.generalInformation.transferCode,
              'SELECTED',
            ),
          );
      } else {
        this.fleetForm
          .get('generalInfo')
          .get('rentCarCode')
          .patchValue(
            this.checkedValuePatch(
              this.vehicleCatCode.applicableRentCodes,
              [],
              'ADD',
            ),
          );
        this.fleetForm
          .get('generalInfo')
          .get('transferCode')
          .patchValue(
            this.checkedValuePatch(
              this.vehicleCatCode.applicableTransferCodes,
              [],
              'ADD',
            ),
          );
      }
    }
  }

  checkedValuePatch(data: any[], selectedVal: any[], type: string) {
    const arr: any[] = [];
    data.map((val: any) => {
      if (type === 'SELECTED') {
        const code = selectedVal.find((co: any) => co === val.value);
        if (code) {
          arr.push({ label: val.label, value: val.value, checked: true });
        } else {
          // if don't want all select and disable remove checked true
          arr.push({ label: val.label, value: val.value, checked: true });
        }
      } else if (type === 'ADD') {
        // if don't want all select and disable remove checked true
        arr.push({ label: val.label, value: val.value, checked: true });
      }
    });
    return arr;
  }

  vehicleImageUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_FLEET_VEHICLE_IMAGES_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Image has been uploaded!`);
        const data = res as any;
        this.vehicleImgUploadFiles.push(data.url);
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_FLEET_VEHICLE_IMAGES_UPLOAD,
          loading: false,
        });
      });

  vehicleBookUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_FLEET_VEHICLE_BOOK_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.vehicleBookUploadFile.push({
          name: item.file.name,
          url: data.url,
        });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_FLEET_VEHICLE_BOOK_UPLOAD,
          loading: false,
        });
      });
  vehicleOtherInfoUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_FLEET_VEHICLE_OTHER_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        console.log(data);
        this.vehicleOtherInfoUploadFiles.push({
          name: item.file.name,
          url: data.url,
        });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_FLEET_VEHICLE_OTHER_UPLOAD,
          loading: false,
        });
      });
  bankInfoUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_FLEET_BANK_DETAILS_UPLOAD)
      .subscribe((res) => {
        const data = res as any;
        this.bankInfoUploadFiles.push({ name: item.file.name, url: data.url });
        this.message.create('success', `Attachment has been uploaded!`);
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_FLEET_BANK_DETAILS_UPLOAD,
          loading: false,
        });
      });

  removeUploadFile(index: any, field: string): void {
    switch (field) {
      case 'general':
        this.vehicleImgUploadFiles.splice(index, 1);
        // this.message.create('success', `Attachment has been deleted!`);
        break;
      case 'owner':
        this.vehicleBookUploadFile.splice(index, 1);
        break;
      case 'other_details':
        this.vehicleOtherInfoUploadFiles.splice(index, 1);
        break;
      case 'payment':
        this.bankInfoUploadFiles.splice(index, 1);
        break;
    }
    this.message.create('success', `Attachment has been deleted!`);
  }

  submit() {
    let payload = {};

    const generalInformation = {
      ...this.fleetForm.get('generalInfo').getRawValue(),
      vehicleImg: this.vehicleImgUploadFiles,
    };
    generalInformation.rentCarCode = this.getCheckedValue(
      generalInformation.rentCarCode,
    );
    generalInformation.transferCode = this.getCheckedValue(
      generalInformation.transferCode,
    );
    generalInformation.vehicleType = this.fleetForm
      .get('generalInfo')
      .get('vehicleType')
      .getRawValue();
    const ownershipDetails = {
      ...this.fleetForm.get('ownerInfo').getRawValue(),
      vehicleBook: this.vehicleBookUploadFile,
    };
    ownershipDetails.ownerName = this.fleetForm
      .get('ownerInfo')
      .get('ownerName')
      .getRawValue();
    const vehicleDetails = {
      ...this.fleetForm.get('vehicleInfo').getRawValue(),
    };
    vehicleDetails.vehicleBrand = this.fleetForm
      .get('vehicleInfo')
      .get('vehicleBrand')
      .getRawValue();
    vehicleDetails.vehicleModel = this.fleetForm
      .get('vehicleInfo')
      .get('vehicleModel')
      .getRawValue();
    vehicleDetails.manufactureDate = this.fleetForm
      .get('vehicleInfo')
      .get('manufactureDate')
      .getRawValue();
    vehicleDetails.registrationNumber = this.fleetForm
      .get('vehicleInfo')
      .get('registrationNumber')
      .getRawValue();
    const agreementDetails = {
      ...this.fleetForm.get('agreementInfo').getRawValue(),
    };
    const vehicleInventory = {
      ...this.fleetForm.get('vehicleInventoryInfo').getRawValue(),
      nextServiceMileage:
        this.fleetForm
          .get('vehicleInventoryInfo')
          .get('latestServiceMileage')
          .getRawValue() +
        this.fleetForm
          .get('vehicleInventoryInfo')
          .get('serviceDuration')
          .getRawValue(),
      nextOilChangedMileage:
        this.fleetForm
          .get('vehicleInventoryInfo')
          .get('latestOilChangedMileage')
          .getRawValue() +
        this.fleetForm
          .get('vehicleInventoryInfo')
          .get('oilChangeDuration')
          .getRawValue(),
    };
    const otherDetails = {
      ...this.fleetForm.get('otherInfo').getRawValue(),
      otherInfoFiles: this.vehicleOtherInfoUploadFiles,
    };
    const paymentDetails = {
      ...this.fleetForm.get('paymentInfo').getRawValue(),
      bankInfoFiles: this.bankInfoUploadFiles,
    };
    if (this.sectionHideByVehicleType) {
      payload = {
        generalInformation,
        vehicleDetails,
        vehicleInventory,
        otherDetails,
        currentMileage: vehicleInventory.odometer,
        currentFuelLevel: vehicleInventory.fuelLevel,
      };
    } else {
      payload = {
        generalInformation,
        ownershipDetails,
        vehicleDetails,
        agreementDetails,
        vehicleInventory,
        otherDetails,
        paymentDetails,
        currentMileage: vehicleInventory.odometer,
        currentFuelLevel: vehicleInventory.fuelLevel,
      };
    }
    this.createOrUpdateFleet(payload);
  }

  getCheckedValue(data: any[]) {
    const arr: any[] = [];
    data.map((val: any) => {
      if (val.checked === true) {
        arr.push(val.value);
      }
    });
    return arr;
  }

  async createOrUpdateFleet(payload: any): Promise<any> {
    try {
      if (this.fleetForm.valid) {
        if (this.fleetId) {
          await this.fleetService
            .updateFleet({
              _id: this.fleetId,
              ...payload,
            })
            .then(() => {
              this.message.create('success', `Vehicle has been updated!`);
            });

          if (this.backLocation === 'single') {
            this.subbmit = true;
            this.router.navigate([`/admin/fleets/${this.fleetId}`]);
          } else {
            this.subbmit = true;
            this.router.navigate(['/admin/fleets']);
          }
        } else {
          const fleetData = await this.fleetService.createFleet(payload);
          this.subbmit = true;
          if (
            _.includes(
              localStorage.getItem(SETTINGS.USER_PERMISSIONS),
              'INVENTORY_RECORDS_CREATE',
            )
          ) {
            this.router.navigate([
              `admin/fleets/${fleetData._id}/inventory/add-edit`,
              { id: '', status: 'Initial' },
            ]);
          } else {
            this.router.navigate([`admin/fleets`]);
          }
        }
        this.fleetForm.reset();
        this.vehicleImgUploadFiles = [];
        this.vehicleBookUploadFile = [];
        this.vehicleOtherInfoUploadFiles = [];
        this.bankInfoUploadFiles = [];
      } else {
        this.actionMessage = new ActionAlert(
          true,
          'Please check required fields',
          'error',
        );
      }
    } catch (e: any) {
      if (e.engineNumCheck || e.chassisNumCheck || e.regNumCheck) {
        this.actionMessage = new ActionAlert(true, e.message, 'error');
      } else {
        // this.message.error('New user has not been added!');
      }
    }
  }

  fleetCancel() {
    this.fleetForm.reset();
    this.vehicleImgUploadFiles = [];
    this.vehicleBookUploadFile = [];
    this.vehicleOtherInfoUploadFiles = [];
    this.bankInfoUploadFiles = [];
    if (this.backLocation === 'single') {
      this.router.navigate([`/admin/fleets/${this.fleetId}`]);
    } else {
      this.router.navigate(['/admin/fleets']);
    }
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.subbmit) {
      return true;
    } else if (this.fleetForm.dirty || this.fleetForm.touched) {
      return confirm(
        ' You have unsaved changes, Do you really want to discard these changes?',
      );
    } else {
      return true;
    }
  }
}
